import React, { RefObject } from 'react';
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import { SpaceBetween } from 'utils/style/extendable';
import {
  CollectionContent,
  CollectionItem,
  Description,
  ItemAvatar,
  MoreSpan,
  Title,
  Filled,
  ItemContainer,
  BadgeContainer,
  BadgeLinkIcon,
  Mask,
  BadgeContent,
  MoreActions,
  FileSizeAlert,
} from './styles';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import ErrorView from 'components/ErrorView/ErrorView';
import Icon from 'components/Icon';
import Input from 'components/Input';
import { navigate } from '@reach/router';
import { setClipboard } from '../../../Tasks/TasksManagement/TaskUtils';
import notify from '../../../../components/Notify';
import { green, blue, exactWhite } from '../../../../utils/style/colors';
import { convertDigitToProperFormat } from '../../../../utils/number';
import {
  creatingItemCanceled,
  item_delete,
  itemStatus,
  updateItem,
} from 'store/providers/providerSlice';
import LocalIcon from 'ui/LocalIcon';
import {
  IconColorFinder,
  IconLogoFinder,
} from '../../../../utils/check-file-type/findIconViaType';
import AlertModal from '../../../../components/Modal/AlertModal';
import i18n, { languageDirection } from '../../../../i18n';
import { getLangFromLocalStorage } from '../../../../utils/LanguageLocalStorage';
import {
  IProvider,
  IProviderDocumentViewObj,
  IProviderItems,
  IProviderItemViewWithData,
  IProviderLinkView,
  providerItemType,
} from '../../../../store/providers/providerTypes';
import RenameView from './RenameView';
import ItemTask from './ItemTask';
import messages from './Messages';
import ChangeThumbnailModal from './ChangeThumbnailModal';
import ChangeLimitationModal from './ChangeLimitationModal';
import ContentTasksModal from './ContentTasksModal';
import { IconType } from 'recharts';
import IconTypes from '../../../../components/Icon/IconTypes';
import ChangeExternalLink from './ChangeExternalLink';
import { getDomainAndPort } from 'api/Utils';
import BlurModal from './BlurModal';
import styled from 'styled-components';
import displayLg from 'assets/images/displayLg.png';
import displayXLg from 'assets/images/displayXLg.png';
import displayMd from 'assets/images/displayMd.png';
import displayShine from 'assets/images/displayShine.png';
import displaySm from 'assets/images/displaySm.png';
import displayText from 'assets/images/displayText.png';
import displaySlider from 'assets/images/displaySlider.png';
import displayTinder from 'assets/images/displayTinder.png';

import { appDispatch } from 'store/store';

interface IMenuItem {
  message?: string;
  callBack?: () => void;
  order?: number;
  icon?: string;
  color?: string;
  group?: string;
  useItemIcon?: boolean;
}

export interface ItemViewTemplate {
  id: number;
  title: string;
  canCreate: boolean;
}

export interface IComponentProps {
  dispatch: (action: any) => any;
  item: IProviderItemViewWithData;
  isLink: {
    id: number;
    sourceItemId: number;
    description: string;
  };
  provider: IProvider;
  selected: boolean;
  items: IProviderItems['items'];
  isOwner: boolean;
  onRestoreItem: (itemId: number) => void;
  onDeleteItemLink: (itemId: number, dadId: number) => void;
  templates: ItemViewTemplate[];
  isSearch: boolean;
  onMoveItem: () => void;
  expectedOrder: number;
  onOpenItem: (
    item: IProviderItemViewWithData,
    type: string,
    a?: undefined,
    b?: boolean,
    extraProps?: any
  ) => void;
}

export interface IComponentState {
  rename: boolean;
  loading: boolean;
  showDropdown: boolean;
  showTaskModal:
    | {
        templateId?: number;
        taskId?: number;
      }
    | undefined;
  showContentTasksList: boolean;
  relatedTemplateId: number | undefined;
  showChangeLimitationModal: boolean;
  showDeleteModal: boolean;
  activeLanguage: string | null;
  openThumbnail: boolean;
  modalTitle: string;
  editLink: boolean;
  enableDisplayModeModal: boolean;
  displayMode:
    | 'display_sm'
    | 'display_shine'
    | 'display_md'
    | 'display_lg'
    | 'display_xlg'
    | 'display_text'
    | 'display_tinder'
    | 'display_slider';
  isItemTemplateModeIsLarge: boolean;
  isIsolatedHtml: boolean;
}

const PictureContainer = styled.div`
  border-radius: 1rem;

  background: url(${(props) => props.bg}) no-repeat center center / contain;
  height: 8rem;
  width: 16rem;
`;

const BlurModalContainer = styled.div`
  max-height: 70vh;
  overflow: auto;
`;

const DisplayModeContainer = styled.div`
  margin-bottom: 2rem;
  & > div {
    display: flex !important;
    flex-direction: column !important;
    height: 8rem !important;
  }
`;

const MB_SIZE = 1_000_000;

const { Menu, MenuItem, MenuDivider } = Dropdown;

export function getItemUrl(item: IProviderItemViewWithData) {
  const id = item.data.id;
  const providerId = item.data.providerId;
  const type = item.data.type;
  const linkPath =
    type === 'folder'
      ? `/content/${providerId}/f/${id}`
      : `/content/${providerId}/direct/${id}`;
  return window.location.protocol + '//' + window.location.host + linkPath;
}

class ItemView<
  P extends IComponentProps = IComponentProps,
  S extends IComponentState = IComponentState,
> extends React.PureComponent<P, S> {
  protected deleteModalContainer: RefObject<HTMLInputElement>;
  protected container: RefObject<HTMLInputElement>;
  protected nameInput: any;
  constructor(props: P) {
    const viewTypeList = props.item.data?.viewType?.split(',');
    super(props);
    this.state = {
      rename: false,
      loading: false,
      showDropdown: false,
      showTaskModal: undefined,
      showContentTasksList: false,
      relatedTemplateId: undefined,
      showChangeLimitationModal: false,
      showDeleteModal: false,
      openThumbnail: false,
      modalTitle: '',
      activeLanguage: getLangFromLocalStorage(),
      editLink: false,
      enableDisplayModeModal: false,
      displayMode:
        viewTypeList?.find((el: string) => el.startsWith('display_')) ||
        'display_sm',
      isItemTemplateModeIsLarge: viewTypeList?.includes('card_lg') || false,
      isIsolatedHtml: viewTypeList?.includes('display_isolated_html') || false,
    } as S;
    this.deleteModalContainer = React.createRef();
    this.container = React.createRef();
    this.getCreatingView = this.getCreatingView.bind(this);
    this.getMenuActions = this.getMenuActions.bind(this);
  }

  componentDidMount() {
    this.componentDidUpdate();
  }
  componentDidUpdate() {
    if (this.deleteModalContainer?.current) {
      ($(this.deleteModalContainer.current) as any).modal();
    }
  }

  // @ts-expect-error jsx error
  deleteItemTitle(name: string) {
    throw new Error(
      `please provide deleteItemTitle() for ${this.constructor.name}`
    );
  }

  // @ts-expect-error jsx error
  deleteItemMessage(name: string) {
    throw new Error(
      `please provide deleteItemMessage() for ${this.constructor.name}`
    );
  }

  // @ts-expect-error jsx error
  onOpenFunction(item: IProviderItemViewWithData, isNewTab?: boolean) {
    throw new Error(
      `please provide onOpenFunction() for ${this.constructor.name}`
    );
  }

  getThumbnail() {
    throw new Error(
      `please provide getThumbnail() for ${this.constructor.name}`
    );
  }

  // @ts-expect-error jsx error
  handelConfirmCreatingNewItem(item: IProviderItemViewWithData) {
    throw new Error(
      `please provide handelConfirmCreatingNewItem() for ${this.constructor.name}`
    );
  }

  newItemPlaceHolder() {
    throw new Error(
      `please provide newItemPlaceHolder() for ${this.constructor.name}`
    );
  }

  newItemTitle() {
    throw new Error(
      `please provide newItemTitle() for ${this.constructor.name}`
    );
  }

  // @ts-expect-error jsx error
  getBadgeView(item?: IProviderItemViewWithData): null | React.ReactNode {
    return null;
  }

  handleShowTaskModal = (templateId: number | null | undefined) => () => {
    this.setState({
      showTaskModal: { templateId: templateId as number },
      showDropdown: false,
    });
  };

  handleShowTaskModalForTaskId = (taskId: number) => {
    this.setState({ showTaskModal: { taskId, templateId: undefined } });
  };

  handleShowTasksList = (templateId?: number, title?: string) => () => {
    this.setState((prevState: S) => ({
      ...prevState,
      showContentTasksList: !prevState.showContentTasksList,
      showDropdown: false,
      relatedTemplateId: templateId,
      modalTitle: title as string,
    }));
  };

  handleChangeDisplayMode = () => {
    this.setState({ enableDisplayModeModal: true, showDropdown: false });
  };

  getMenuActions(itemId: number, editable: boolean) {
    let menu: IMenuItem[] = [];
    const enableDispalyMode =
      getDomainAndPort().domainFeatures?.enableItemDisplayMode;
    if (this.props.item.data.status === 'deleted') {
      if (
        this.props.items[this.props.item.data.dadId]?.data?.status === 'exists'
      )
        menu.push({
          message: i18n.t('restore', { ns: 'documentManager' }),
          callBack: () => {
            this.props.onRestoreItem(itemId);
            this.setState({ showDropdown: false });
          },
          order: 1,
          group: '1-actions',
          icon: 'rotate-cw',
          color: 'red',
        });
      return menu;
    }

    if (this.props.isLink && editable) {
      menu = [
        {
          message: i18n.t('deleteLink', { ns: 'documentManager' }),
          callBack: () => {
            this.props.onDeleteItemLink(
              this.props.isLink.id,
              this.props.isLink.sourceItemId
            );
            this.setState({ showDropdown: false });
          },
          order: 1,
          group: '1-actions',
          icon: 'delete',
          color: 'red',
        },
      ];
    } else if (editable) {
      menu = [
        {
          message: i18n.t('rename', { ns: 'documentManager' }),
          callBack: () => {
            this.setState({ rename: true, showDropdown: false });
          },
          group: '1-actions',
          order: 1,
          icon: 'edit',
        },
        {
          message: i18n.t('changeThumbnail', { ns: 'documentManager' }),
          callBack: this.handleChangeThumbnail,
          group: '1-actions',
          order: 2,
          icon: 'image',
        },
        {
          message: i18n.t('changeLimitation', { ns: 'documentManager' }),
          callBack: this.handleChangeLimitation,
          group: '1-actions',
          order: 3,
          icon: 'lock',
        },
        {
          message: i18n.t('delete', { ns: 'documentManager' }),
          callBack: () => {
            this.setState(
              { showDropdown: false, showDeleteModal: true },
              () => {
                if (this.deleteModalContainer.current)
                  ($(this.deleteModalContainer.current) as any).modal('open');
              }
            );
          },
          order: 5,
          group: '1-actions',
          icon: 'trash-2',
          color: 'red',
        },
      ];

      if (this.props.isOwner) {
        menu.push({
          message: i18n.t('move', { ns: 'documentManager' }),
          callBack: this.handleMoveItem,
          order: 6,
          group: '1-actions',
          icon: 'move',
        });
      }
    }

    if (this.props.templates) {
      this.props.templates.forEach((template) => {
        menu.push({
          message: i18n.t('showTemplate', {
            ns: 'documentManager',
            title: template.title,
          }),
          callBack: this.handleShowTasksList(
            template.id,
            i18n.t('modalTitle', {
              ns: 'documentManager',
              itemName: this.props.item.data.name,
              taskName: template.title,
            })
          ),
          order: 8,
          group: '2-task',
          color: blue,
          icon: 'layers',
        });
        if (template.canCreate)
          menu.push({
            message: i18n.t('createTemplate', {
              ns: 'documentManager',
              title: template.title,
            }),
            callBack: this.handleShowTaskModal(template.id),
            order: 8,
            icon: 'file-plus',
            color: green,
            group: '2-task',
          });
      });
    }

    if (this.props.isSearch || this.props.isLink) {
      const menuItem = {
        message: i18n.t('showInParent', { ns: 'documentManager' }),
        callBack: () => {
          const dadId = this.props.item.data.dadId;
          const providerId = this.props.item.data.providerId;
          navigate(`/content/${providerId}/f/${dadId}`);
        },
        order: 0,
        icon: 'eye',
        group: '0-search',
      };
      menu.push(menuItem);
    }

    menu.push({
      message: i18n.t('copyLink', { ns: 'documentManager' }),
      callBack: () => {
        const item = this.props.item;
        const url = getItemUrl(item);
        setClipboard(url);
        notify(i18n.t('linkCopiedToClipboard', { ns: 'documentManager' }));
        this.setState({ showDropdown: false });
      },
      order: 0.5,
      group: '0-search',
      icon: 'link',
    });

    if (enableDispalyMode && editable) {
      menu.push({
        message: i18n.t('configDisplayMode', { ns: 'documentManager' }),
        callBack: this.handleChangeDisplayMode,
        order: 2,
        group: '1-actions',
        icon: 'grid',
      });
    }

    return menu;
  }

  handleMoveItem = () => {
    this.setState({ showDropdown: false });
    this.props.onMoveItem();
  };

  handleDeleteItem = () => {
    return this.props.dispatch(item_delete({ item: this.props.item.data }));
  };

  handleCompleteRenaming = () => {
    this.setState({ rename: false });
  };

  createNewItem = (e: any) => {
    e.preventDefault();
    const item = cloneDeep(this.props.item);
    item.data.name = this.nameInput.value;
    item.data.order = this.props.expectedOrder;

    this.handelConfirmCreatingNewItem(item);
  };

  deleteItem() {
    if (this.container.current) {
      ($(this.container.current) as any).slideUp({
        done: () => this.handleDeleteItem(),
      });
    }
  }

  handleChangeThumbnail = () => {
    this.setState({
      openThumbnail: !this.state.openThumbnail,
      showDropdown: false,
    });
  };

  handleChangeLimitation = () => {
    this.setState(({ showChangeLimitationModal }) => ({
      showChangeLimitationModal: !showChangeLimitationModal,
      showDropdown: false,
    }));
  };

  getProgressBar() {
    return (
      <div className="progress">
        <div className="indeterminate" />
      </div>
    );
  }

  handelCancelCreatingNewItemFunction = () => {
    this.props.dispatch(creatingItemCanceled({ item: this.props.item.data }));
  };

  handleCloseModal = () => {
    this.setState({ showDeleteModal: false });
  };

  handleSubmitModal = () => {
    this.deleteItem();
    this.setState({ showDeleteModal: false });
  };

  handleClickDisplayModeFormat = (value: S['displayMode']) => {
    this.setState({ displayMode: value });
  };

  handleSaveDisplayMode = () => {
    this.setState({ loading: true });
    const item = cloneDeep(this.props.item);
    const displayMode = this.state.displayMode;
    const cardLg = 'card_lg';
    item.data.viewType = this.state.isItemTemplateModeIsLarge
      ? `${displayMode},${cardLg}`
      : `${displayMode}`;

    if (this.state.isIsolatedHtml)
      item.data.viewType = item.data.viewType
        ? `${item.data.viewType},display_isolated_html`
        : item.data.viewType;

    appDispatch(updateItem({ item: item.data })).then(() => {
      this.setState({
        // isItemTemplateModeIsLarge: false,
        enableDisplayModeModal: false,
        // displayMode: 'display_sm',
        loading: false,
      });
    });
  };

  getCreatingView(formChildren?: any, actionChildren?: any) {
    // @ts-expect-error JSX Error
    const [iconType, iconColor] = this.getThumbnail();
    if (!formChildren) {
      formChildren = null;
    }
    if (!actionChildren) {
      actionChildren = null;
    }
    const {
      item: {
        data: { name },
        error,
      },
    } = this.props;

    console.log(
      this.props.item.data?.type,
      this.props.item.data?.document?.fileSize
    );

    const hasValidFileSize =
      this.props.item.data?.type === 'document'
        ? Math.round(this.props.item.data?.document?.fileSize / MB_SIZE) < 500
        : true;

    return (
      <CollectionItem>
        <CollectionContent>
          <ItemAvatar>
            <LocalIcon iconName={iconType} color={iconColor} type="lg" />
          </ItemAvatar>
          <form onSubmit={this.createNewItem}>
            <Input
              id="name"
              type="text"
              autoComplete="off"
              required={true}
              defaultValue={name as string}
              forwardRef={(el) => {
                this.nameInput = el;
              }}
              placeholder={(this.newItemPlaceHolder() as any as string) || ''}
              label={(this.newItemTitle() as any as string) || ''}
            />
            {formChildren}
            {/* @ts-expect-error JSX Error */}
            <ErrorView className="red-text" err={error} />
            {!hasValidFileSize && (
              <FileSizeAlert>
                <div>
                  <LocalIcon
                    iconName="alert.svg"
                    color={exactWhite}
                    type="sm"
                  />
                </div>
                <div>
                  {
                    i18n.t('fileExceededSize', {
                      ns: 'documentManager',
                    }) as string
                  }
                </div>
              </FileSizeAlert>
            )}
            <SpaceBetween>
              <Button type="submit" color="green" disabled={!hasValidFileSize}>
                {i18n.t('confirm', { ns: 'documentManager' }) as string}
              </Button>
              {actionChildren}
              <Button
                color="red"
                onClick={this.handelCancelCreatingNewItemFunction}
              >
                {i18n.t('cancel', { ns: 'documentManager' }) as string}
              </Button>
            </SpaceBetween>
          </form>
        </CollectionContent>
      </CollectionItem>
    );
  }

  handleShowDropdown = (showDropdown: boolean) => {
    this.setState({ showDropdown });
  };

  render() {
    const { dispatch, item, isLink, provider, selected } = this.props;
    // @ts-expect-error JSX Error
    const [iconType, iconColor] = this.getThumbnail();
    if (!item) return <div />;
    if (item.status === itemStatus.uploading) {
      return (
        <CollectionItem key={item.data.id}>
          <CollectionContent>
            <ItemAvatar>
              <LocalIcon iconName={iconType} color={iconColor} />
            </ItemAvatar>
          </CollectionContent>
          <div style={{ width: '100%' }}>
            <div className="full-width valign">
              <div
                className="title"
                style={{
                  textWrap: 'wrap',
                  wordBreak: 'break-word',
                }}
              >
                {item.data.name}
              </div>
            </div>
            <div className="row no-margin" style={{ width: '100%' }}>
              <div className="col s12">{this.getProgressBar()}</div>
            </div>
          </div>
        </CollectionItem>
      );
    } else if (this.state.loading) {
      return (
        <CollectionItem key={item.data.id}>
          <CollectionContent>
            <ItemAvatar>
              <LocalIcon iconName={iconType} color={iconColor} />
            </ItemAvatar>
            <div className="full-width valign">
              <div
                className="title"
                style={{
                  textWrap: 'wrap',
                  wordBreak: 'break-word',
                }}
              >
                {item.data.name}
              </div>
            </div>
          </CollectionContent>
          {this.getProgressBar()}
        </CollectionItem>
      );
    }
    if (item.status === undefined || item.status === itemStatus.exists) {
      const IconLogo = IconLogoFinder({
        type: item.data.type,
        format: item.data?.document?.properties.format,
        tags: item.data?.tags,
      });
      const bgColor = IconColorFinder(item.data.type);

      if (
        this.state.editLink &&
        item.data.type === providerItemType.externalLink
      ) {
        return (
          <ChangeExternalLink
            item={item}
            iconColor={iconColor}
            iconType={iconType}
            afterSave={() => this.setState({ editLink: false })}
          />
        );
      }

      if (this.state.rename) {
        return (
          <RenameView
            item={item}
            onComplete={this.handleCompleteRenaming}
            color={bgColor}
            icon={IconLogo}
          />
        );
      }
      const menuActions = this.getMenuActions(item.data.id, item.data.editable);

      return (
        <div ref={this.container} key={item.data.id}>
          {this.state.showTaskModal && this.state.showTaskModal?.templateId && (
            <ItemTask
              companyId={provider.managingCompanyId as number}
              templateId={this.state.showTaskModal.templateId}
              providerItem={item.data}
              tab={'info'}
              onTaskCreate={(taskId) => {
                this.handleShowTaskModalForTaskId(taskId);
              }}
              onClose={this.handleShowTaskModal(undefined)}
              taskId={'new'}
            />
          )}
          {this.state.showTaskModal && this.state.showTaskModal.taskId && (
            <ItemTask
              companyId={provider.managingCompanyId as number}
              taskId={this.state.showTaskModal.taskId}
              tab={'info'}
              onClose={this.handleShowTaskModal(undefined)}
            />
          )}
          <ItemContainer
            className="hover-area clickable"
            onClick={this.onOpenFunction(item)}
            onContextMenu={(e: Event) => {
              e.preventDefault();
              e.stopPropagation(); // Prevent event propagation
              this.setState({ showDropdown: true });
            }}
            selected={selected}
          >
            {!selected && <Mask />}
            <BadgeContainer bgColor={bgColor} selected={selected}>
              <BadgeContent>{<LocalIcon iconName={IconLogo} />}</BadgeContent>
              {isLink && (
                <BadgeLinkIcon>
                  <LocalIcon iconName="horizontal-link.svg" type="sm" />
                </BadgeLinkIcon>
              )}
            </BadgeContainer>
            <Title deleted={item.data.status === 'deleted'} selected={selected}>
              <div style={{ wordWrap: 'break-word', width: '100%' }}>
                {item.data.name}
              </div>
              {isLink && <Description>{isLink.description}</Description>}
              {item.data.type === 'link' &&
                item.data.name !==
                  (item.data as IProviderLinkView).providerName && (
                  <Description>
                    {(item.data as IProviderLinkView).providerName}
                  </Description>
                )}
              {item.data.type === 'document' &&
                (item.data as IProviderDocumentViewObj).versions &&
                (item.data as IProviderDocumentViewObj).versions.length > 1 && (
                  <Description>
                    {i18n.t('version', { ns: 'documentManager' })}
                    {
                      (item.data as IProviderDocumentViewObj).versions.find(
                        (it: any) =>
                          it.document.id ===
                          (item.data as IProviderDocumentViewObj)
                            .currentDocumentId
                      )?.properties.name
                    }
                  </Description>
                )}
              {item.data.type === 'survey' &&
                !!item.data?.myResponseInfo?.filledPeriods?.length &&
                item.data.myResponseInfo.filledPeriods.length > 0 && (
                  <Filled
                    title={
                      !messages?.[item.data.myResponseInfo.filledPeriods?.[0]]
                        ? i18n.t('lastFilled', { ns: 'documentManager' })
                        : ''
                    }
                  >
                    <span>
                      {
                        i18n.t(
                          `${
                            [item.data.myResponseInfo.filledPeriods[0]] ||
                            convertDigitToProperFormat(
                              item.data.myResponseInfo.filledPeriods[0]
                            )
                          }`,
                          { ns: 'documentManager' }
                        ) as string
                      }
                    </span>
                    <Icon type="check" color="white" />
                  </Filled>
                )}
            </Title>
            <span>
              <span style={{ zIndex: '399' }}>
                <MoreActions>
                  <li
                    className={
                      this.state.showDropdown ? '' : 'visible-on-hover'
                    }
                  >
                    <Dropdown
                      marginToTarget={0}
                      placement="bottom-start"
                      onShowChange={this.handleShowDropdown}
                      show={this.state.showDropdown}
                      width={250}
                      target={
                        <MoreSpan>
                          <Icon type="more-horizontal" />
                        </MoreSpan>
                      }
                    >
                      <Menu>
                        {typeof menuActions === 'object' &&
                        menuActions.length > 0
                          ? menuActions
                              .sort((a, b) =>
                                a.group === b.group
                                  ? (a.order as any) - (b.order as any)
                                  : (a.group ?? '').localeCompare(b.group ?? '')
                              )
                              .map((element: any, index, list) => {
                                if (element.type === 'divider') {
                                  return <MenuDivider key={index} />;
                                }
                                return (
                                  <>
                                    {index > 0 &&
                                    element.group !== list[index - 1].group ? (
                                      <MenuDivider key={index} />
                                    ) : (
                                      <div />
                                    )}
                                    {
                                      <MenuItem key={element.message}>
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (element && element.callBack)
                                              element.callBack();
                                          }}
                                          style={{
                                            display: 'flex',
                                            alignItems: `${languageDirection() === 'rtl' ? 'center' : 'baseline'}`,
                                          }}
                                        >
                                          <Icon
                                            style={{ marginInlineEnd: '5px' }}
                                            type={
                                              (element.icon ||
                                                'dash') as IconTypes
                                            }
                                            color={element.color as IconType}
                                          />{' '}
                                          {element.message}
                                        </span>
                                      </MenuItem>
                                    }
                                  </>
                                );
                              })
                          : null}
                      </Menu>
                    </Dropdown>
                  </li>
                  {this.getBadgeView(item)}
                </MoreActions>
              </span>
            </span>
          </ItemContainer>
          <AlertModal
            content={this.deleteItemMessage(item.data.name as string)}
            onSubmit={this.handleSubmitModal}
            onCancel={this.handleCloseModal}
            isActive={this.state.showDeleteModal}
          />

          <BlurModal
            isOpen={this.state.enableDisplayModeModal}
            onCloseModal={() =>
              this.setState({ enableDisplayModeModal: false })
            }
            // maxWidth="80vw"
            title={i18n.t('configDisplayMode', { ns: 'documentManager' })}
          >
            <BlurModalContainer>
              {['folder', 'searchTag'].includes(item.data.type) && (
                <DisplayModeContainer>
                  <h4 className="mb-4 font-bold">
                    {
                      i18n.t('displayTemplate', {
                        ns: 'documentManager',
                      }) as string
                    }
                  </h4>
                  <Input
                    id={'dispModeXLG' + item.data.id.toString()}
                    label={
                      <div className="flex gap-2" style={{ height: '8rem' }}>
                        <div style={{ flex: '1' }}>
                          {
                            i18n.t('xlgDisplay', {
                              ns: 'documentManager',
                            }) as string
                          }
                        </div>
                        <PictureContainer bg={displayXLg} />
                      </div>
                    }
                    type="radio"
                    checked={this.state.displayMode === 'display_xlg'}
                    onClick={() =>
                      this.handleClickDisplayModeFormat('display_xlg')
                    }
                  />
                  <Input
                    id={'dispModeLg' + item.data.id.toString()}
                    label={
                      <div className="flex gap-2">
                        <div style={{ flex: '1' }}>
                          {
                            i18n.t('lgDisplay', {
                              ns: 'documentManager',
                            }) as string
                          }
                        </div>
                        <PictureContainer bg={displayLg} />
                      </div>
                    }
                    type="radio"
                    checked={this.state.displayMode === 'display_lg'}
                    onClick={() =>
                      this.handleClickDisplayModeFormat('display_lg')
                    }
                  />
                  <Input
                    id={'DispModeMd' + item.data.id.toString()}
                    label={
                      <div className="flex gap-2">
                        <div style={{ flex: '1' }}>
                          {
                            i18n.t('mdDisplay', {
                              ns: 'documentManager',
                            }) as string
                          }
                        </div>
                        <PictureContainer bg={displayMd} />
                      </div>
                    }
                    type="radio"
                    checked={this.state.displayMode === 'display_md'}
                    onClick={() =>
                      this.handleClickDisplayModeFormat('display_md')
                    }
                  />
                  <Input
                    id={'DispShine' + item.data.id.toString()}
                    label={
                      <div className="flex gap-2">
                        <div style={{ flex: '1' }}>
                          {
                            i18n.t('shineDisplay', {
                              ns: 'documentManager',
                            }) as string
                          }
                        </div>
                        <PictureContainer bg={displayShine} />
                      </div>
                    }
                    type="radio"
                    checked={this.state.displayMode === 'display_shine'}
                    onClick={() =>
                      this.handleClickDisplayModeFormat('display_shine')
                    }
                  />
                  <Input
                    id={'DispModeText' + item.data.id.toString()}
                    label={
                      <div className="flex gap-2" style={{ height: '8rem' }}>
                        <div style={{ flex: '1' }}>
                          {
                            i18n.t('textDisplay', {
                              ns: 'documentManager',
                            }) as string
                          }
                        </div>
                        <PictureContainer bg={displayText} />
                      </div>
                    }
                    type="radio"
                    checked={this.state.displayMode === 'display_text'}
                    onClick={() =>
                      this.handleClickDisplayModeFormat('display_text')
                    }
                  />
                  <Input
                    id={'DispSM' + item.data.id.toString()}
                    label={
                      <div className="flex gap-2">
                        <div style={{ flex: '1' }}>
                          {
                            i18n.t('smDisplay', {
                              ns: 'documentManager',
                            }) as string
                          }
                        </div>
                        <PictureContainer bg={displaySm} />
                      </div>
                    }
                    type="radio"
                    checked={this.state.displayMode === 'display_sm'}
                    onClick={() =>
                      this.handleClickDisplayModeFormat('display_sm')
                    }
                  />
                  <Input
                    id={'DispSlider' + item.data.id.toString()}
                    label={
                      <div className="flex gap-2">
                        <div style={{ flex: '1' }}>
                          {
                            i18n.t('sliderDisplay', {
                              ns: 'documentManager',
                            }) as string
                          }
                        </div>
                        <PictureContainer bg={displaySlider} />
                      </div>
                    }
                    type="radio"
                    checked={this.state.displayMode === 'display_slider'}
                    onClick={() =>
                      this.handleClickDisplayModeFormat('display_slider')
                    }
                  />
                  <Input
                    id={'DispTinder' + item.data.id.toString()}
                    label={
                      <div className="flex gap-2">
                        <div style={{ flex: '1' }}>
                          {
                            i18n.t('tinderDisplay', {
                              ns: 'documentManager',
                            }) as string
                          }
                        </div>
                        <PictureContainer bg={displayTinder} />
                      </div>
                    }
                    type="radio"
                    checked={this.state.displayMode === 'display_tinder'}
                    onClick={() =>
                      this.handleClickDisplayModeFormat('display_tinder')
                    }
                  />
                </DisplayModeContainer>
              )}
              <div className="flex flex-col gap-2">
                <h4 className="mb-4 font-bold" style={{ lineHeight: '1.5rem' }}>
                  {
                    i18n.t('ItemDisplayMode', {
                      ns: 'documentManager',
                    }) as string
                  }
                </h4>
                <Input
                  id={'itemTemplate' + item.data.id.toString()}
                  type="checkbox"
                  checked={this.state.isItemTemplateModeIsLarge || false}
                  onChange={() =>
                    this.setState({
                      isItemTemplateModeIsLarge:
                        !this.state.isItemTemplateModeIsLarge,
                    })
                  }
                  label={
                    i18n.t('showItemToLarge', {
                      ns: 'documentManager',
                    }) as string
                  }
                />

                {item.data.document?.properties.format === 'quill' && (
                  <Input
                    id={'display_isolated_html' + item.data.id.toString()}
                    type="checkbox"
                    checked={this.state.isIsolatedHtml || false}
                    onChange={() =>
                      this.setState({
                        isIsolatedHtml: !this.state.isIsolatedHtml,
                      })
                    }
                    label={
                      i18n.t('showItemAsSPA', {
                        ns: 'documentManager',
                      }) as string
                    }
                  />
                )}
                <Button
                  color="black-outline"
                  onClick={this.handleSaveDisplayMode}
                  loading={this.state.loading}
                >
                  {i18n.t('save', { ns: 'documentManager' }) as string}
                </Button>
              </div>
            </BlurModalContainer>
          </BlurModal>

          {this.state.openThumbnail ? (
            <ChangeThumbnailModal
              item={item.data}
              dispatch={dispatch}
              isOpen={this.state.openThumbnail}
              onCloseThumbnailModal={() =>
                this.setState({ openThumbnail: false })
              }
            />
          ) : null}
          {this.state.showChangeLimitationModal && (
            <ChangeLimitationModal
              item={item}
              onComplete={this.handleChangeLimitation}
              managingCompanyId={provider.managingCompanyId}
              limitAccessToCompany={provider.limitAccessToCompany}
            />
          )}
          {provider.managingCompanyId && this.state.showContentTasksList && (
            <ContentTasksModal
              modalTitle={this.state.modalTitle}
              companyId={provider.managingCompanyId}
              providerItemId={item.data.id}
              onCloseContentTasksModal={this.handleShowTasksList()}
              templateId={this.state.relatedTemplateId}
            />
          )}
        </div>
      );
    } else if (item.status === itemStatus.creating) {
      return this.getCreatingView();
    }
    return null;
  }
}

export default ItemView;
